import React from "react";
import SvgIcon from "./SvgIcon";

const CompareSelected = ({
  label1,
  label2,
  selectedItem1,
  selectedItem2,
  compareFunction,
  closeFunction,
  isTopButtonVisible,
  compareName,
  isModalOpened,
}) => {
  return (
    <>
      {(selectedItem1 || selectedItem2) &&
      !isTopButtonVisible &&
      !isModalOpened ? (
        <div className="floating-globe">
          <div className="action-buttons only-show-mobile">
            {closeFunction && (
              <SvgIcon
                src={"/img/new-icons/red-cross.svg"}
                onClickFn={closeFunction}
                noFilterOnLight={true}
              />
            )}
          </div>
          <div>
            <p className="p4">{label1}</p>
            <h4>{selectedItem1 || "-"}</h4>
          </div>
          <div>
            <p className="p4">{label2}</p>
            <h4>{selectedItem2 || "-"}</h4>
          </div>
          <div className="action-buttons">
            <button
              data-button-type="primary"
              disabled={!selectedItem1 || !selectedItem2 ? true : undefined}
              onClick={compareFunction}
            >
              Compare {compareName}
            </button>
            {closeFunction && (
              <SvgIcon
                src={"/img/new-icons/red-cross.svg"}
                onClickFn={closeFunction}
                noFilterOnLight={true}
                classNames="mobile-hidden"
              />
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CompareSelected;
